import './info-notice.scss';
